import aggridUtils from "./aggrid-utils.js";

export const DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL = Object.freeze({
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressHeaderContextMenu: true,
    suppressFloatingFilterButton: true,
    comparator: (a, b, nodeA, nodeB, isDescending) => aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isDescending),
});

export const DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL_FLOATING_FILTERS = Object.freeze({
    suppressHeaderMenuButton: true,
    suppressHeaderFilterButton: true,
    suppressHeaderContextMenu: true,
    suppressFloatingFilterButton: true,
    filter: true,
    floatingFilter: true,
    comparator: (a, b, nodeA, nodeB, isDescending) => aggridUtils.nullLastComparator(a, b, nodeA, nodeB, isDescending),
});

export function customFormatDate(dateString) {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('T')[0].split('-');
    return `${day}/${month}/${year}`;
}


